console.log("Context Engine Loaded");

function extractKnownAnswers(message){

    const answers = {};

    //----------------------------------
    // Location
    //----------------------------------


const text = message.toLowerCase();

if(text.includes("garden")){

    answers.location = "Garden";

}
else if(text.includes("home")){

    answers.location = "Home";

}
else if(text.includes("office")){

    answers.location = "Office";

}
else if(text.includes("shop")){

    answers.location = "Shop";

}
else if(text.includes("warehouse")){

    answers.location = "Warehouse";

}
else if(text.includes("outdoor")){

    // Outdoor cameras are usually for gardens,
    // entrances, parking, etc.

    answers.location = "Garden";

}
else if(text.includes("indoor")){

    answers.location = "Home";

}

    //----------------------------------
    // Budget
    //----------------------------------

    const budget = detectBudget(message);

    if(budget){

        if(budget.type === "MAX"){

            answers.budget = "Under ₹" + budget.amount;

        }

        else if(budget.type === "MIN"){

            answers.budget = "Above ₹" + budget.amount;

        }

        else{

            answers.budget = "₹" + budget.amount;

        }

    }

    //----------------------------------
    // Wi-Fi
    //----------------------------------

    if(message.toLowerCase().includes("wifi")){

        answers.wifi = "Yes";

    }

    if(
        message.toLowerCase().includes("without wifi") ||
        message.toLowerCase().includes("no wifi")
    ){

        answers.wifi = "No";

    }

    return answers;

}